import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'aphrodite'

export const MapPin = ({ text, styleSheet, onBreak = true }) => (
  <div className={css(styleSheet.dotParent)}>
    <div
      className={css(styleSheet.pinDot)}
      style={{ backgroundColor: onBreak ? '#308dff' : '#ff3030' }}
    />
    <span className={css(styleSheet.pinText)}>{text}</span>
  </div>
)

MapPin.propTypes = {
  styleSheet: PropTypes.object.isRequired,
  text: PropTypes.string,
  onBreak: PropTypes.bool,
}

export default MapPin



// WEBPACK FOOTER //
// ./src/components/MapPin/MapPin.js